import { cn } from '@core/utils';

//* 'use client' 모듈의 상수는 서버 컴포넌트(스켈레톤)에서 클라이언트 참조로 바뀌어 값이 안 읽힌다 — 공용 클래스는 여기 둔다
export const WEEKLY_TOP_SECTION_CLASS_NAME = cn(
  'flex w-full flex-col gap-16 bg-Gray-25 py-64',
  'mobile-tablet:gap-16 mobile-tablet:bg-transparent mobile-tablet:py-0',
);

//* 두 열이 한 화면에 들어가는 폭(640~)은 2열 그리드로 채우고, 그보다 좁을 때만 가로 스크롤로 다음 열을 살짝 보인다
export const WEEKLY_TOP_LIST_CLASS_NAME = cn(
  'mt-8 grid w-full grid-cols-2 gap-24 px-40 content-container',
  'mobile-tablet:mt-0 mobile-tablet:gap-16 mobile-tablet:px-20',
  'max-[639px]:flex max-[639px]:snap-x max-[639px]:snap-mandatory max-[639px]:scroll-px-20 max-[639px]:overflow-x-auto max-[639px]:hide-scrollbar',
);

export const WEEKLY_TOP_COLUMN_CLASS_NAME = cn(
  'flex flex-col gap-20 rounded-large bg-Gray-white px-28 py-24',
  'mobile-tablet:gap-16 mobile-tablet:rounded-none mobile-tablet:bg-transparent mobile-tablet:p-0',
  'max-[639px]:w-292 max-[639px]:shrink-0 max-[639px]:snap-start',
);
